import axios from "@/libs/api.request.js";

// 微信小游戏企微承接 -- 领取活动礼包码
export const drawActivityReward = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/drawReward`,
    data,
    method: "post",
    requireToken: true
  });
};

// 微信小游戏企微承接 -- 推送活动首页
export const getActivityDetail = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/activityHome`,
    data,
    method: "post",
    requireToken: true
  });
};

// 微信小游戏企微承接 -- 绑定openid
export const bandUserOpenid = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/bindWechat`,
    data,
    method: "post",
    requireToken: true
  });
};

// 微信小游戏企微承接 -- 领取签到礼包码
export const drawSignReward = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/drawSignGift`,
    data,
    method: "post",
    requireToken: true,
    judgeCode: true,
  });
};

// 企微自动化转游 --根据openid + wxappid 获取企微用户ID
export const getQwzyuidByOpenidAndWxappid = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/enterpriseUserInfo`,
    data,
    method: "post",
    requireToken: true
  });
};

// 企微活动规则
export const getActivityRule = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/activityRule`,
    data,
    method: "post",
    requireToken: true
  });
};

// 领取三日促投礼包
export const drawPromoteGift = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/drawPromoteGift`,
    data,
    method: "post",
    requireToken: true,
    judgeCode: true,
  });
};

// 企微小游戏转游活动 -- 获取活动详情
export const getTransformActivityHome = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/transformActivityHome`,
    data,
    method: "post",
    requireToken: true
  });
};

// 企微小游戏转游活动 -- 领取礼包
export const drawTransformGift = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/drawTransformGift`,
    data,
    method: "post",
    requireToken: true
  });
};

// 企微转游促单活动首页
export const getTransformPromoteHome = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/wechatEnterprisePromoteHomeList`,
    data,
    method: "post",
    requireToken: true
  });
};

// 企微转游促单活动首页 -- 领取
export const drawTransformPromoteGift = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/promoteEnterpriseDrawReward`,
    data,
    method: "post",
    requireToken: true,
    judgeCode: true,
  });
};

// 企微转游促单活动首页 -- 领取记录
export const getTransformPromoteRecord = (data) => {
  return axios.request({
    url: `/platform-box-game/wechat/promoteEnterpriseDrawInfo`,
    data,
    method: "post",
    requireToken: true
  });
};

// 召回维护 - 获取活动角色区服信息
export const getAfterCallActRoleList = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/activityRoleInfo`,
    data,
    method: "post",
    requireToken: true
  });
};

// 召回维护 - 活动礼包领取记录
export const getAfterCallActRewardRecord = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/activityGiftDrawInfo`,
    data,
    method: "post",
    requireToken: true
  });
};

// 企微活动规则 (新, 新增多礼包规则)
export const getAllActivityRule = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/activityRuleV2`,
    data,
    method: "post",
    requireToken: true
  });
};

// 领取多礼包
export const onReceiveMultiGift = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/drawActivityManyGift`,
    data,
    method: "post",
    requireToken: true,
    judgeCode: true,
  });
};

// 切换角色
export const switchRole = (data) => {
  return axios.request({
    url: `/platform-box-game/enterpriseWx/changeRoleInfo`,
    data,
    method: "post",
    requireToken: true
  });
};
